/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import * as angular from 'angular';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';
let anyWindow: any = window;

const options = {
	// The minimum amount of movement that will trigger a move event (with a mouse)
	minimumMoveMouse: 2,
	// The minimum amount of movement that will trigger a move event (with a touch)
	minimumMoveTouch: 7,
};

angular.module('CanvasWrapper').factory('InteractionTap', TapFactory);
/**
 * @namespace Tap
 * @returns {CanvasWrapper.Interaction.Tap}
 * @memberOf CanvasWrapper.Interaction
 * @constructor
 */
TapFactory.$inject = ['InteractionHandleEvent'];
function TapFactory(InteractionHandleEvent) {
	let handleEvent = InteractionHandleEvent;
	function Tap(displayNode) {
		function mouseDown(e) {
			start(e, e.data.originalEvent);
		}

		function touchStart(e) {
			if (!e || !e.data || !e.data.originalEvent || !e.data.originalEvent.targetTouches) {
				return;
			}
			start(e, e.data.originalEvent.targetTouches[0]);
		}

		// possibly be called twice or more
		function start(e, t) {
			if (displayNode._tap) {
				return;
			}
			displayNode._tap = {
				p: {
					x: t.clientX,
					y: t.clientY,
				},
			};
			handleEvent(displayNode).on('mousemove', mouseMove);
			handleEvent(displayNode).on('touchmove', touchMove);
		}

		function mouseMove(e) {
			move(e, e.data.originalEvent);
		}

		function touchMove(e) {
			let t = e.data.originalEvent.targetTouches;
			if (!t || t.length > 1) {
				displayNode._tap.canceled = true;
				end(e);
				return;
			}
			move(e, t[0]);
		}

		function move(e, t) {
			let dx = t.clientX - displayNode._tap.p.x;
			let dy = t.clientY - displayNode._tap.p.y;
			let distance = Math.sqrt(dx * dx + dy * dy);
			let threshold = t instanceof anyWindow.MouseEvent ? options.minimumMoveMouse : options.minimumMoveTouch;
			if (distance > threshold) {
				displayNode._tap.canceled = true;
			}
		}

		// possibly be called twice or more
		function end(e) {
			if (displayNode._tap && !displayNode._tap.canceled) {
				let event = {
					data: e.data,
				};
				handleEvent(displayNode).emit('simpletap', event);
			}
			displayNode._tap = null;
			handleEvent(displayNode).removeListener('mousemove', mouseMove);
			handleEvent(displayNode).removeListener('touchmove', touchMove);
		}

		displayNode.eventMode = EventMode.Static;
		handleEvent(displayNode).on('mousedown', mouseDown);
		handleEvent(displayNode).on('touchstart', touchStart);
		handleEvent(displayNode).on('mouseup', end);
		handleEvent(displayNode).on('mouseupoutside', end);
		handleEvent(displayNode).on('touchend', end);
		handleEvent(displayNode).on('touchendoutside', end);
	}

	return Tap;
}
